// extracted by mini-css-extract-plugin
module.exports = {"mb":"ThemeToggle_mb__2kCAq","dk":"ThemeToggle_dk__2ZSN8"};